import { faClone } from '@fortawesome/free-regular-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a clone icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/clone?f=classic&s=regular
 */
export function CloneIcon(props: CustomIconProps) {
  return <Icon icon={faClone} {...props} />;
}
